module.exports = __webpack_public_path__ + "img/1920_news_main_img2.83d9aa4f.png";